import React, { useState, useEffect } from "react";
import { Drawer, List, ListItemButton, ListItemIcon, ListItemText, Toolbar, Divider, Collapse, useMediaQuery, } from "@mui/material";
import DashboardIcon from "@mui/icons-material/Dashboard";
import CategoryIcon from "@mui/icons-material/Category";
import InventoryIcon from "@mui/icons-material/Inventory";
import Inventory2Icon from "@mui/icons-material/Inventory2";
import PeopleIcon from "@mui/icons-material/People";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import ImageIcon from "@mui/icons-material/Image";
import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import LocationCityIcon from "@mui/icons-material/LocationCity";
import ExpandLessIcon from "@mui/icons-material/ExpandLess";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import SettingsIcon from "@mui/icons-material/Settings";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import AssessmentIcon from "@mui/icons-material/Assessment";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import ShoppingBagIcon from "@mui/icons-material/ShoppingBag";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import DiamondIcon from "@mui/icons-material/Diamond";
import { useNavigate, useLocation } from "react-router-dom";
const drawerWidth = 300;
export default function Sidebar({ open, setOpen }) {
    const navigate = useNavigate();
    const location = useLocation();
    const isMobile = useMediaQuery("(max-width:900px)");
    const [masterOpen, setMasterOpen] = useState(
        location.pathname.startsWith("/masters")
    );
    useEffect(() => {
        if (isMobile) {
            setOpen(false);
        }
    }, [isMobile, setOpen]);
    useEffect(() => {
        if (location.pathname.startsWith("/masters")) {
            setMasterOpen(true);
        }
    }, [location.pathname]);
    const handleNavigate = (path) => {
        navigate(path);
        if (isMobile) setOpen(false);
    };
    const isActive = (path) => location.pathname === path;
    const handleMasterClick = () => {
        setMasterOpen((prev) => !prev);
    };
    return (
        <Drawer variant={isMobile ? "temporary" : "permanent"} open={open} onClose={() => setOpen(false)} sx={{ width: drawerWidth, flexShrink: 0, "& .MuiDrawer-paper": { width: drawerWidth, boxSizing: "border-box", }, }}>
            <Toolbar><h3>Jewellery Admin</h3></Toolbar>
            <Divider />
            <List>
                <ListItemButton selected={isActive("/dashboard")} onClick={() => handleNavigate("/dashboard")}>
                    <ListItemIcon><DashboardIcon color="primary" /></ListItemIcon>
                    <ListItemText primary="Dashboard" />
                </ListItemButton>
                <Divider />
                <ListItemButton onClick={handleMasterClick}>
                    <ListItemIcon><SettingsIcon color="primary" /></ListItemIcon>
                    <ListItemText primary="Masters" />
                    {masterOpen ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                </ListItemButton>
                <Collapse in={masterOpen} timeout="auto" unmountOnExit>
                    <ListItemButton sx={{ pl: 4 }} selected={isActive("/masters/state")} onClick={() => handleNavigate("/masters/state")}>
                        <ListItemIcon>
                            <span className="material-symbols-outlined">map</span>
                        </ListItemIcon>
                        <ListItemText primary="State" />
                    </ListItemButton>
                    <List component="div" disablePadding>
                        <ListItemButton sx={{ pl: 4 }} selected={isActive("/masters/district")} onClick={() => handleNavigate("/masters/district")}>
                            <ListItemIcon>
                                <span className="material-symbols-outlined">location_city</span>
                            </ListItemIcon>
                            <ListItemText primary="District" />
                        </ListItemButton>
                        <ListItemButton sx={{ pl: 4 }} selected={isActive("/masters/plan-category")} onClick={() => handleNavigate("/masters/plan-category")}>
                            <ListItemIcon><CategoryIcon /></ListItemIcon>
                            <ListItemText primary="Plan Category" />
                        </ListItemButton>
                        <ListItemButton sx={{ pl: 4 }} selected={isActive("/masters/product-category")} onClick={() => handleNavigate("/masters/product-category")}>
                            <ListItemIcon><CategoryIcon /></ListItemIcon>
                            <ListItemText primary="Product Category" />
                        </ListItemButton>
                    </List>
                </Collapse>
                <Divider />
                <ListItemButton selected={isActive("/banner")} onClick={() => handleNavigate("/banner")}>
                    <ListItemIcon><ImageIcon color="primary" /></ListItemIcon>
                    <ListItemText primary="Banner List" />
                </ListItemButton>
                <Divider />
                <ListItemButton selected={isActive("/today-rate")} onClick={() => handleNavigate("/today-rate")}>
                    <ListItemIcon><CurrencyRupeeIcon color="primary" /></ListItemIcon>
                    <ListItemText primary="Today Rate List" />
                </ListItemButton>
                <Divider />
                <ListItemButton selected={isActive("/products")} onClick={() => handleNavigate("/products")}>
                    <ListItemIcon><DiamondIcon color="primary" /></ListItemIcon>
                    <ListItemText primary="App Products List" />
                </ListItemButton>
                <Divider />
                <ListItemButton selected={isActive("/billing-products")} onClick={() => handleNavigate("/billing-products")}>
                    <ListItemIcon><Inventory2Icon color="primary" /></ListItemIcon>
                    <ListItemText primary="Billing Products List" />
                </ListItemButton>
                <Divider />
                <ListItemButton selected={isActive("/purchase-entry")} onClick={() => handleNavigate("/purchase-entry")}>
                    <ListItemIcon><ShoppingCartIcon color="primary" /></ListItemIcon>
                    <ListItemText primary="Purchase Bill" />
                </ListItemButton>
                <Divider />
                <ListItemButton selected={isActive("/sales-entry")} onClick={() => handleNavigate("/sales-entry")}>
                    <ListItemIcon><PointOfSaleIcon color="primary" /></ListItemIcon>
                    <ListItemText primary="Sales Bill" />
                </ListItemButton>
                <Divider />
                <ListItemButton selected={isActive("/estimate-entry")} onClick={() => handleNavigate("/estimate-entry")}>
                    <ListItemIcon><ReceiptLongIcon color="primary" /></ListItemIcon>
                    <ListItemText primary="Estimate Bill" />
                </ListItemButton>
                <Divider />
                <ListItemButton selected={isActive("/user-enquiry-list")} onClick={() => handleNavigate("/user-enquiry-list")}>
                    <ListItemIcon><SupportAgentIcon color="primary" /></ListItemIcon>
                    <ListItemText primary="Plan Enquiry List" />
                </ListItemButton>
                <Divider />
                <ListItemButton selected={isActive("/orders")} onClick={() => handleNavigate("/orders")}>
                    <ListItemIcon><ShoppingCartIcon color="primary" /></ListItemIcon>
                    <ListItemText primary="Product Enquiry List" />
                </ListItemButton>
                <Divider />
                <ListItemButton selected={isActive("/plans")} onClick={() => handleNavigate("/plans")}>
                    <ListItemIcon><ShoppingBagIcon color="primary" /></ListItemIcon>
                    <ListItemText primary="Savings Plan List" />
                </ListItemButton>
                <Divider />
                <ListItemButton selected={isActive("/users")} onClick={() => handleNavigate("/users")}>
                    <ListItemIcon><PeopleIcon color="primary" /></ListItemIcon>
                    <ListItemText primary="Savings Plan Users List" />
                </ListItemButton>
                <Divider />
                <ListItemButton selected={isActive("/user-plan-list")} onClick={() => handleNavigate("/user-plan-list")}>
                    <ListItemIcon><ShoppingBagIcon color="primary" /></ListItemIcon>
                    <ListItemText primary="Savings Scheme List" />
                </ListItemButton>
                <Divider />
                <ListItemButton selected={isActive("/reports")} onClick={() => handleNavigate("/reports")}>
                    <ListItemIcon><AssessmentIcon color="primary" /></ListItemIcon>
                    <ListItemText primary="Reports" />
                </ListItemButton>
                <Divider />
            </List>
        </Drawer>
    );
}